export const VOICEMAILS_VIEW_ID = 'voicemails';
export const ALL_VIEW_ID = 'all';
export const RECORDED_CALLS_VIEW_ID = 'recorded_calls';